import { render, staticRenderFns } from "./Ball.vue?vue&type=template&id=06e93874&scoped=true&"
import script from "./Ball.vue?vue&type=script&lang=js&"
export * from "./Ball.vue?vue&type=script&lang=js&"
import style0 from "./Ball.vue?vue&type=style&index=0&id=06e93874&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e93874",
  null
  
)

export default component.exports